<div class="dialog-close-btn">
    <button mat-icon-button (click)="onNoClick()">
        <i class="material-icons">
            close
        </i>
    </button>
</div>
<fusioncharts [chartConfig]=chartConfig [dataSource]="dataSource">
</fusioncharts>